import { render } from "./EcoPortal1.vue?vue&type=template&id=24823063&scoped=true"
import script from "./EcoPortal1.vue?vue&type=script&lang=js"
export * from "./EcoPortal1.vue?vue&type=script&lang=js"

import "./EcoPortal1.vue?vue&type=style&index=0&id=24823063&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24823063"]])

export default __exports__